import { render, staticRenderFns } from "./SidebarDesktop.vue?vue&type=template&id=5c280a86&scoped=true"
import script from "./SidebarDesktop.vue?vue&type=script&lang=ts"
export * from "./SidebarDesktop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c280a86",
  null
  
)

export default component.exports